import { faAnglesUp, faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@orobix/orobix-fe-components'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Results, TrainingTestOutcome } from '../../../types'
import { get } from '../../../utils/api'
import { handleApiErrors } from '../../../utils/apiErrors'
import { getQueryString } from '../../../utils/queryString'
import { usePromoteAnnotation } from './usePromoteAnnotation'

interface PromoteAnnotationButtonProps {
  trainingTestId: number
  observationId: number
}

const PromoteAnnotationButton = ({
  trainingTestId,
  observationId,
}: PromoteAnnotationButtonProps) => {
  const { t } = useTranslation()
  const [label, setLabel] = useState('')
  const [title, setTitle] = useState('')
  const {
    promoteAnnotationByTrainingAndObservation: promoteAnnotation,
    isPromoting,
  } = usePromoteAnnotation()
  const [isPromoted, setIsPromoted] = useState(true)

  useEffect(() => {
    const queryString = getQueryString({
      trainingTest: trainingTestId,
      observation: observationId,
    })

    // Fetch current observation data
    get<Results<TrainingTestOutcome>>(`/training_test_outcomes/?${queryString}`)
      .then((response) => {
        setIsPromoted(
          response.results[0].latestObservationAnnotation?.promotedFrom?.id ===
            response.results[0].observationAnnotation?.id
        )
      })
      .catch(handleApiErrors)
  }, [observationId, trainingTestId])

  useEffect(() => {
    if (isPromoting) {
      setLabel(t('Promoting...'))
      setTitle(t('Promoting prediction to ground truth...'))
    } else if (isPromoted) {
      setLabel(t('Promoted'))
      setTitle(t('Prediction already promoted to ground truth.'))
    } else {
      setLabel(t('Promote'))
      setTitle(
        t(
          'Promote this prediction to annotation to use it as ground truth in trainings.'
        )
      )
    }
  }, [t, isPromoted, isPromoting])

  return (
    <Button
      onClick={() => {
        promoteAnnotation(trainingTestId, observationId)
        setIsPromoted(true)
      }}
      label={label}
      title={title}
      icon={<FontAwesomeIcon icon={isPromoted ? faCheck : faAnglesUp} />}
      buttonType="button"
      size="sm"
      disabled={isPromoted || isPromoting}
      loading={isPromoting}
    />
  )
}

export default PromoteAnnotationButton
